var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"w-100"},[_vm._v("\n  Appointment CANCELLED\n  "),_c('appointment-object',{attrs:{"appointment-number":_vm.appointmentNumber()}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }